import { localization } from "../localizationManager";

export var farsiStrings = {
  groupButton: "گروه بندی با",
  ungroupButton: "حذف گروه",
  selectButton: "انتخاب",
  hideColumn: "مخفی کردن ستون",
  showColumn: "نمایش ستون",
  moveToDetail: "انتقال به جزئیات",
  showAsColumn: "نمایش به عنوان ستون",
  visualizer_text: "متون در جدول",
  visualizer_wordcloud: "ابر کلمات",
  chartType_bar: "میله ای",
  chartType_pie: "دابره ای(pie)",
  chartType_scatter: "پراکندگی(Scatter)",
  chartType_gauge: "عقربه ای",
  chartType_bullet: "Bullet",
  hideButton: "مخفی",
  resetFilter: "بازنشانی فیلترها",
  clearButton: "پاک کردن",
  addElement: "انتخاب سوال برای نمایش..."
};

localization.locales["fa"] = farsiStrings;
localization.localeNames["fa"] = "Farsi(Persian)";
